<template>
  <div>
    <h5 class="mb-3">Estado de pedidos</h5>
    <div class="input-group mb-3">
      <input 
        v-model="filterValue"
        type="text"
        placeholder="Buscar"
        class=""
      >
      <div class="input-group-append">
        <button 
          @click=" filterValue = '' "
          class="btn-biv btn-delete"><i class="fa fa-remove"></i></button>      
      </div>
    </div>

    <div class="table_desc">
      <div class="cart_page table-responsive">        
        <table :class=" { 'loading': dataLoading } ">
          <thead>
            <tr>
              <th width="50">#</th>              
              <th @click="sortBy('ref')" :class="{ 'mouseHover': true, 'th-active': (sortKey == 'ref') ? true : false } ">
                Referencia<span :class=" refSortIcon "></span>
              </th>
              <th @click="sortBy('date')" width="110" :class="{ 'mouseHover small-headers': true, 'th-active': (sortKey == 'date') ? true : false } ">
                Fecha Pedido<span :class=" dateSortIcon "></span>
              </th>
              <th @click="sortBy('update')" width="115" :class="{ 'mouseHover small-headers': true, 'th-active': (sortKey == 'update') ? true : false } ">
                Última Actualización<span :class=" updateSortIcon "></span>
              </th>
              <th @click="sortBy('state')" width="110" :class="{ 'mouseHover small-headers': true, 'th-active': (sortKey == 'state') ? true : false } ">
                Estado<span :class=" stateSortIcon "></span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for=" (item, index) in dataRawFiltered " :key="item.id">
              <td>{{ index + 1 }}</td>
              <td class="text-left">{{ item.ref }}</td>
              <td>{{ formatDate(item.date) }}</td>
              <td>{{ formatDate(item.update) }}</td>
              <td>{{ item.state }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex';

  export default {
    data() {
      return {
        dataLoading: false,
        /* dataRaw: [], */
        dataRaw: [
          {
            "id": 1,
            "date": '2020/02/10',
            "ref": 'REF234887-7889-0001',
            "update": '2020/02/11',
            "state": 'En tránsito'
          },
          {
            "id": 2,
            "date": '2020/01/22',
            "ref": 'REF234887-7889-0002',
            "update": '2020/01/25',
            "state": 'Entregado'
          },
          {
            "id": 3,
            "date": '2019/12/01',
            "ref": 'REF234887-7889-0003',
            "update": '2020/02/10',
            "state": 'Entregado'
          },
          {
            "id": 4,
            "date": '2020/02/05',
            "ref": 'REF234887-7889-0004',
            "update": '2020/02/06',
            "state": 'En proceso'
          },
          {
            "id": 5,
            "date": '2020/01/02',
            "ref": 'REF234887-7889-0005',
            "update": '2020/01/18',
            "state": 'Entregado'
          }
        ],
        filterValue: '',
        dataRawLength: '',
        sortKey: '',
        sortOrder: '',
        sortStyles: {},
      }      
    },
    mounted () {
      //this.loadData();
    },
    computed: {	
      ...mapGetters( ['getApiUrl'] ),		
      dataRawFiltered: function(){
        // STRING FILTERING
        /*this.actualPage = 1;*/
        var filteredData =  this.dataRaw.filter( (item) => {
          let tmp = false;
          Object.keys(item).forEach( key => {
            if( item[key] != null ){
              if( item[key].toString().toLowerCase().includes(this.filterValue.toLowerCase()) ){
                tmp = true;
              }
            }
          });
          return ( tmp ) ? item : null
        });

        // SORTING
        if( this.sortKey ){
          return this.$_.orderBy(filteredData, [this.sortKey], [this.sortOrder]);
        }else{
          return filteredData;
        }
      },
      refSortIcon: function(){
        if( this.sortKey == 'ref' && this.sortOrder == 'asc' ){
          return 'fa fa-sort-alpha-asc ml-1'
        }else if ( this.sortKey == 'ref' && this.sortOrder == 'desc' ){
          return 'fa fa-sort-alpha-desc ml-1'
        }else {
          return 'invisible'
        }
      },
      dateSortIcon: function(){
        if( this.sortKey == 'date' && this.sortOrder == 'asc' ){
          return 'fa fa-sort-numeric-asc ml-1'
        }else if ( this.sortKey == 'date' && this.sortOrder == 'desc' ){
          return 'fa fa-sort-numeric-desc ml-1'
        }else {
          return 'invisible'
        }
      },
      updateSortIcon: function(){
        if( this.sortKey == 'update' && this.sortOrder == 'asc' ){
          return 'fa fa-sort-numeric-asc ml-1'
        }else if ( this.sortKey == 'update' && this.sortOrder == 'desc' ){
          return 'fa fa-sort-numeric-desc ml-1'
        }else {
          return 'invisible'
        }
      },
      stateSortIcon: function(){
        if( this.sortKey == 'state' && this.sortOrder == 'asc' ){
          return 'fa fa-sort-alpha-asc ml-1'
        }else if ( this.sortKey == 'state' && this.sortOrder == 'desc' ){
          return 'fa fa-sort-alpha-desc ml-1'
        }else {
          return 'invisible'
        }
      },
    },
    methods: {
      ...mapMutations(['mutateGlobalMessage']),
      loadData(){
        this.dataLoading = true

        this.$axios.get( this.getApiUrl + '')
        .then(response => {
          this.dataRaw = response.data.data          
          this.dataLoading = false
          
        }).catch((error) => {
          let  message = '';
          if (error.response.data.hasOwnProperty('message')) {
            message = error.response.data.message;
          }else{
            message = error
          }
          this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: 'Error', message:   message } )
          this.dataLoading = false
        });
      },
      formatDate(value){
        return new Date(value).toLocaleDateString('es-ES', { year: 'numeric', day: '2-digit', month: '2-digit' })
      },
      sortBy(key){
        if( key == this.sortKey ){
          // Invert order
          this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
        }else{
          // Set ASC order
          this.sortOrder = 'asc';

          if( this.sortKey ){
            this.sortStyles[this.sortKey] = 'sorting';
          }
        }
        this.sortKey = key;
        this.sortStyles[key] = 'sorting_' + this.sortOrder;
      },
      initSortStyles(){
        let keys = this.$_.keys(this.dataRaw[0]);
        for(let i=0;i<keys.length;i++){
          this.sortStyles[''+keys[i]+''] = 'sorting';
        }
      },
    },    
  }
</script>
<style>
  .small-headers{ font-size: 10px !important; font-weight: 500 !important; text-transform: uppercase; line-height: 12px; }
  .th-active{ background-color: #CACDE9; }
  .btn-delete{ background-color: #444; padding: 8px 16px; }
  .btn-delete:hover { background: #2971f5; }
  input{ min-width: 500px !important; }
  input:focus{ border: 1px solid #CACDE9 }
</style>